// @flow

import { jitsiLocalStorage } from '@jitsi/js-utils/jitsi-local-storage';

import { CONFERENCE_JOINED } from '../base/conference';
import { MiddlewareRegistry } from '../base/redux';
import { isLocalCameraTrackMuted } from '../base/tracks';

import { setVirtualBackground, toggleBackgroundEffect } from './actions';

/**
 * Implements the middleware of the Virtual Background feature.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => action => {
    const { getState, dispatch } = store;
    const state = getState();
    const tracks = state['features/base/tracks'];

    switch (action.type) {

    case CONFERENCE_JOINED:
        (async () => {
            if (!isLocalCameraTrackMuted(tracks)) {
                const data = jitsiLocalStorage.getItem('features/virtual-background/images');
                const parser = JSON.parse(data || '{}');

                if (Object.keys(parser).length !== 0) {
                    await dispatch(setVirtualBackground(parser.src, true));
                    await dispatch(toggleBackgroundEffect(true));
                }
            }
        })();

        break;

    }

    return next(action);
});
